export type SearchMethod = 'like' | 'fulltext' | 'regex';
export type VersionsFilter = 'latest' | 'head' | 'all';

export interface SearchRequest {
  method: SearchMethod;
  versions: VersionsFilter;
  query: string;
  // New fields (API 0.3.0)
  projectSearch?: boolean;
  stepSearch?: boolean;
  projectId?: number;
  workflowId?: number;
  // Legacy fields (API 2.6.3) kept for gradual migration
  offset?: number;
  limit?: number;
}

export interface SearchProjectResult {
  projectId: number;
  name: string;
  description: string;
  nameSummary: string;
  descriptionSummary: string;
  rank: number;
}

export interface SearchNotebookResult {
  projectId: number;
  workflowId: number;
  versionId: number;
  majorVersion: number;
  minorVersion: number;
  notebookName: string;
  projectName: string;
  description: string;
  nameSummary: string;
}

export interface SearchChunkResult {
  stepId: number;
  stepType: string;
  stepName: string;
  projectId: number;
  workflowId: number;
  versionId: number;
  majorVersion: number;
  minorVersion: number;
  notebookName: string;
  projectName: string;
  description: string;
  summary: string;
  rank: number;
}

export interface SearchResponse {
  projects: SearchProjectResult[];
  notebooks: SearchNotebookResult[];
  chunks: SearchChunkResult[];
}

// =============================
// New API (0.3.0) search models
// Kept alongside legacy models for phased migration
// =============================

export interface SearchWorkflowResult {
  workflowId: number;
  projectId: number;
  workflowName: string;
  projectName: string;
  nameSummary: string;
}

export interface SearchStepResult {
  stepId: number;
  workflowId: number;
  projectId: number;
  stepName: string;
  stepType: string;
  workflowName: string;
  projectName: string;
  summary: string;
}

export interface SearchResponseV3 {
  projects: SearchProjectResult[];
  workflows: SearchWorkflowResult[];
  steps: SearchStepResult[];
}

export class SearchResultsProcessor {
  toLegacyResponse(v3: SearchResponseV3): SearchResponse {
    return {
      projects: v3.projects,
      notebooks: v3.workflows.map(w => ({
        projectId: w.projectId,
        workflowId: w.workflowId,
        versionId: 0,
        majorVersion: 0,
        minorVersion: 0,
        notebookName: w.workflowName,
        projectName: w.projectName,
        description: '',
        nameSummary: w.nameSummary
      })),
      chunks: v3.steps.map(s => ({
        stepId: s.stepId,
        stepType: s.stepType,
        stepName: s.stepName,
        projectId: s.projectId,
        workflowId: s.workflowId,
        versionId: 0,
        majorVersion: 0,
        minorVersion: 0,
        notebookName: s.workflowName,
        projectName: s.projectName,
        description: '',
        summary: s.summary,
        rank: 0
      }))
    };
  }
}
